export default __webpack_public_path__ + "static/media/green_pawn.e80f3fd4.png";